import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

export default function CampaignsTab() {
  const [subs, setSubs] = useState<any[]>([]);

  useEffect(() => {
    supabase.from("newsletter_subscribers").select("*").order("subscribed_at", { ascending: false })
      .then(({ data }) => setSubs(data ?? []));
  }, []);

  const exportCsv = () => {
    const csv = ["email,subscribed_at,is_active", ...subs.map(s => `${s.email},${s.subscribed_at},${s.is_active}`)].join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "subscribers.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Newsletter Subscribers ({subs.length})</CardTitle>
        <Button onClick={exportCsv} size="sm" variant="outline"><Download className="h-4 w-4 mr-2" />Export CSV</Button>
      </CardHeader>
      <CardContent>
        <div className="space-y-1 max-h-96 overflow-y-auto">
          {subs.map(s => (
            <div key={s.id} className="flex justify-between text-sm p-2 border-b">
              <span>{s.email}</span>
              <span className="text-muted-foreground">{new Date(s.subscribed_at).toLocaleDateString()}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
